/* Growtek blogtema — lille hjælpescript (indholdsfortegnelse)
   1) Giver alle h2 i artiklen et id (til ankerlinks), hvis de mangler
   2) Bygger automatisk indholdsfortegnelsen i <details class="gt-toc" data-auto>
   3) Åbner indholdsfortegnelsen på desktop (den er sticky via CSS) */
(function () {
  function slugify(text) {
    return text.trim().toLowerCase()
      .replace(/[æ]/g, 'ae').replace(/[ø]/g, 'oe').replace(/[å]/g, 'aa')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function init() {
    var scope = document.querySelector('.gt-body') || document.querySelector('.gt-article');
    if (!scope) return;
    var h2s = Array.prototype.slice.call(scope.querySelectorAll('h2'));
    h2s.forEach(function (h) { if (!h.id) h.id = slugify(h.textContent); });
    var toc = document.querySelector('details.gt-toc[data-auto]');
    if (toc && h2s.length) {
      if (!toc.querySelector('summary')) {
        var s = document.createElement('summary');
        s.textContent = 'Indhold';
        toc.appendChild(s);
      }
      var old = toc.querySelector('ol');
      if (old) old.remove();
      var ol = document.createElement('ol');
      h2s.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        ol.appendChild(li);
      });
      toc.appendChild(ol);
    } else if (toc) {
      toc.style.display = 'none';
    }
    var mq = window.matchMedia('(min-width: 1024px)');
    function apply() {
      document.querySelectorAll('details.gt-toc').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();